import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TestimonialGallery = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const images = [
    {
      src: "/images/temoignage1.webp",
      alt: t('TestimonialImageAlt', { num: 1 })
    },
    {
      src: "/images/temoignage2.webp", 
      alt: t('TestimonialImageAlt', { num: 2 })
    },
    {
      src: "/images/temoignage3.webp",
      alt: t('TestimonialImageAlt', { num: 3 })
    }
  ];

  // Gestion du swipe
  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
    if (isRightSwipe && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Navigation avec les boutons
  const goToPrevious = () => {
    setCurrentIndex(currentIndex === 0 ? images.length - 1 : currentIndex - 1);
  };

  const goToNext = () => {
    setCurrentIndex(currentIndex === images.length - 1 ? 0 : currentIndex + 1);
  };

  return (
    <div style={{
      position: "relative",
      width: "274px",
      height: "auto",
      overflow: "hidden",
      borderRadius: "16px"
    }}>
      {/* Image principale */}
      <div
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          position: "relative",
          width: "100%",
          height: "auto"
        }}
      >
        {currentIndex === 0 ? (
          <a
            href="https://upreality.store/p/CaffeCardito"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "block", cursor: "pointer" }}
          >
            <img
              src={images[currentIndex].src}
              alt={images[currentIndex].alt}
              style={{
                width: "274px",
                height: "auto",
                borderRadius: "16px",
                display: "block"
              }}
            />
          </a>
        ) : (
          <img
            src={images[currentIndex].src}
            alt={images[currentIndex].alt}
            style={{
              width: "274px",
              height: "auto",
              borderRadius: "16px",
              display: "block"
            }}
          />
        )}
      </div>

      {/* Indicateurs de pagination */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        marginTop: "12px"
      }}>
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            aria-label={t('TestimonialImageAlt', { num: index + 1 })}
            aria-current={index === currentIndex ? "true" : undefined}
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: index === currentIndex ? "#04d3bc" : "#ccc",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              padding: "0",
              minWidth: "24px",
              minHeight: "24px"
            }}
          />
        ))}
      </div>

      {/* Boutons de navigation (optionnels) */}
      <button
        onClick={goToPrevious}
        aria-label={t('Previous')}
        style={{
          position: "absolute",
          left: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0, 0, 0, 0.5)",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "16px",
          opacity: currentIndex === 0 ? 0.3 : 1
        }}
        disabled={currentIndex === 0}
      >
        ‹
      </button>

      <button
        onClick={goToNext}
        aria-label={t('Next')}
        style={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0, 0, 0, 0.5)",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "16px",
          opacity: currentIndex === images.length - 1 ? 0.3 : 1
        }}
        disabled={currentIndex === images.length - 1}
      >
        ›
      </button>
    </div>
  );
};

export default TestimonialGallery;
